/**
 * What kind of file a dataset row holds, from its latest version's name (or the dataset name)
 * and the parser metadata. Pure module shared by hooks/useDatasetRawLayers (which layers load
 * it) and lib/workflow-steps (which steps apply).
 */

export const VECTOR_EXTS = ['geojson', 'json', 'kml', 'gpx', 'csv', 'txt', 'dat', 'xyz'];
export const RAW_FORMAT_EXTS = ['stg', 'stn', 'ohm', 'res2dinv'];

/** Lower-case file extension of the dataset's file, '' when it has none. */
export function datasetFileExt(ds) {
  const base = String(ds?.latest_version?.storage_path || ds?.name || '').split('/').pop();
  return base.includes('.') ? base.slice(base.lastIndexOf('.') + 1).toLowerCase() : '';
}

/**
 * A plain vector/tabular file (GeoJSON, KML, GPX, CSV, XYZ) that is not a parsed resistivity
 * survey. Its coordinates are already geographic (or mapped on load), so it needs no georef.
 * Rasters are not checked here (lib/raster-api isRasterDataset).
 */
export function isVectorFile(ds) {
  if (!ds) return false;
  const m = ds.metadata || {};
  const ext = datasetFileExt(ds);
  if (m.n_readings != null || m.format || m.raw || RAW_FORMAT_EXTS.includes(ext)) return false;
  return VECTOR_EXTS.includes(ext);
}
